import React from 'react';
import { Form } from 'react-bootstrap';

/**Functional UI component for the search box */
export const SearchBox = (props) => {
    return <Form>
        <Form.Group>
            <Form.Label>Search</Form.Label>
            <Form.Control
                onChange={props.onChange}
                name="Search"
                type="search"
                placeholder="Search via Company Name" />
        </Form.Group>
    </Form>;
};


// WEBPACK FOOTER //
// ./src/components/components/SearchBox.js